var _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-bot-icon lucide-bot",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V4H8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    x: 4,
    y: 8,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13v2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13v2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.264fd6dabf2eb3a736835d6b07abf4ea.svg";
export { ForwardRef as ReactComponent };